import {
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/material';
import { AnnotationGroup } from '../CampaignAnalytics/InfoSection';
import { LIGHT_TEXT_PRIMARY } from '@utils/colorGenerator';

export type EditableProps = {
  editable?: boolean;
  includedInReport?: boolean;
  onToggle?: (toggled: boolean) => void;
  onChange?: (newAnnotations: AnnotationGroup) => void;
};

export type ReportSectionCardHeaderProps = {
  title: string;
  description: string;
  renderHeader?: () => React.ReactNode;
} & EditableProps;

export const SUBHEADER_FONT_SIZE = '12px';

export const ReportSectionCardHeader = (
  props: ReportSectionCardHeaderProps
) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '28px',
          }}
        >
          {props.title}
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: '#616161', fontSize: SUBHEADER_FONT_SIZE }}
        >
          {props.description}
        </Typography>
      </Box>
      <Stack direction="row" alignItems="center" gap="1rem">
        {props.renderHeader?.()}
        {props.editable ? (
          <Box sx={{ color: LIGHT_TEXT_PRIMARY, fontSize: '14px' }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={props.includedInReport}
                    onChange={e => props.onToggle?.(e.target.checked)}
                  />
                }
                label="Include in Report"
              />
            </FormGroup>
          </Box>
        ) : null}
      </Stack>
    </Stack>
  );
};
